import MobileDrawer from '@c/drawers/MobileDrawer';
import { ChevronRight } from 'lucide-react';
import PriceDropIcon from './assets/price-drop-2.svg';
import Image from 'next/image';
import { SmartPricingIcon } from 'i/smart-pricing';
import BaseModal from '@c/modals/BaseModal';
import { isMobile } from '@util/index';

export const PromoteModal = ({
  open,
  setOpen,
  setSmartPricingModalOpen,
  setPriceDropModalOpen,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSmartPricingModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setPriceDropModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const onSelectSmartPricing = () => {
    setOpen(false);
    setSmartPricingModalOpen(true);
  };

  const onSelecetPriceDrop = () => {
    setOpen(false);
    setPriceDropModalOpen(true);
  };

  const _isMobile = isMobile();

  const Base = _isMobile ? MobileDrawer : BaseModal;

  return (
    <Base
      show={open}
      isOpen={open}
      dismiss={() => setOpen((prev) => !prev)}
      title="Promote your listing"
    >
      <div className="flex flex-col gap-12 px-8 py-12">
        <button
          className="flex w-full items-center justify-between"
          onClick={onSelecetPriceDrop}
        >
          <div className="flex items-center gap-5">
            <Image
              src={PriceDropIcon}
              alt="smart pricing icon"
              width={56}
              height={56}
            />
            <div className="flex flex-col items-start gap-2">
              <span className="text-body-md font-semibold">Price drop</span>
              <p className="text-left text-body-sm font-medium text-text-muted">
                Drop the price and we’ll notify the people who liked your item
              </p>
            </div>
          </div>

          <ChevronRight />
        </button>
        <div className="h-px w-full bg-[#d9d9d9]" />
        <button
          className="flex items-center justify-between"
          onClick={onSelectSmartPricing}
        >
          <div className="flex items-center gap-5">
            <SmartPricingIcon className="size-28" />
            <div className="flex flex-col items-start gap-2">
              <span className="text-body-md font-semibold">Smart pricing</span>
              <p className="text-left text-body-sm font-medium text-text-muted">
                Gradually lower the item price every 10 days until it reaches
                the floor price.
              </p>
            </div>
          </div>
          <ChevronRight />
        </button>
      </div>
    </Base>
  );
};
